import { atom } from "jotai";

/** -1 = intro screen (currently disabled), 0..n = index into visibleSteps */
export const shoeFinderStepAtom = atom<number>(0);

/** Maps step _uid → set of selected answer _uids (or size strings on the last step) */
export const shoeFinderSelectionsAtom = atom<Map<string, Set<string>>>(new Map());

export const shoeFinderStartFiredAtom = atom<boolean>(false);
